import classNames from 'classnames';
import style from './index.module.less';

interface RadioProps {
  type: string | null;
  className?: string;
  onChange: () => void;
  onFocus?:() => void;
  name: string;
  checked: boolean;
}

export default function Radio(props: RadioProps) {
  const {type, className, onChange, checked, name, onFocus} = props;
  if (!type) {
    return <input className={className} onChange={onChange} onFocus={onFocus} checked={checked} name={name} type="radio"/>;
  } else {
    return (<div className={classNames(style[type],className)}></div>);
  }
}